(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name leaveDetailReport.controller:LeaveDetailReportCtrl
   *
   * @description
   *
   */
  angular
    .module('leaveDetailReport')
    .controller('LeaveDetailReportCtrl', LeaveDetailReportCtrl);

  function LeaveDetailReportCtrl(CommonMasterData, $sce, crewScheduleService, CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'LeaveDetailReportCtrl';

    vm.model = {
      searchPanelToggle: true,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        leaveTypes: [],
        crewType: null,
        crewBase : null,
        crewId: null,
        crew: null
      },
      masterList: {
        crewTypes: [],
        crewList: [],
        crewBaseList :[],
        leaveTypeList: [],
        fromTimeInvalid: false,
        toTimeInvalid: false
      },
      initialSearchDone: false,
      reportDataURL: null,
      reportServerBaseUrl: null
    };

    // toggle search
    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };


    (function loadCrewTypes() {
      CommonMasterData.getCrewTypeList(
        function (crewTypes) {
          vm.model.masterList.crewTypes = crewTypes;
          // vm.model.masterList.msgRecipients = crewTypes;
        },
        function () {
          console.log('Crew type retrieval error');
        }
      );
    })();

    (function loadLeaveTypes() {
      CommonMasterData.getLeaveTypeList(
        function (leaveTypes) {
          vm.model.masterList.leaveTypeList = leaveTypes
          vm.model.masterList.leaveTypeList.push({eventCode:"SWA"},{eventCode:"SWO"})
          angular.forEach(leaveTypes, function (leaveType) {  vm.model.searchCriteria.leaveTypes.push(leaveType);  });
        },
        function () {
          console.log('Leave type retrieval error');
        }
      );
    })();


    vm.changeSearchField = function (searchCriteria, flag) {
      if (flag == 'crewType') {
        vm.model.searchCriteria.crewId = '';
        if (vm.model.searchCriteria.crewType == null) {
          vm.model.masterList.crewList = [];
          vm.model.searchCriteria.crew = null;
        } else {
          loadCrewList(searchCriteria.crewType.crewTypeCode);
        }
      } else if (flag == 'crewId') {
        vm.model.searchCriteria.crewType = null;
        vm.model.searchCriteria.crew = '';
        vm.model.masterList.crewList = [];

      } else if (flag == 'crewName') {
        if(!!vm.model.searchCriteria.crew) {
          vm.model.searchCriteria.crewId = vm.model.searchCriteria.crew.crewId;
        }
      }

    }

    function loadCrewList(crewType) {

      var load = function () {
        var param = {};
        param.crewType = crewType;
        param.active = true;

        CommonMasterData.loadCrewList(param,
          function (response) {
            vm.model.masterList.crewList = crewScheduleService.adaptCrewList(response);
          },
          function () {
            console.log('Crew list retrieval error');
          }
        );
      };

      //always loading the crewlist
      load();
    }

    // submit search
    vm.submitSearch = function (params) {
      searchLeaveDetailsReport(params);
    };

    function searchLeaveDetailsReport(param) {
      vm.model.initialSearchDone = true;
      if (isValidSearchParams(param)) {
        vm.model.searchCriteria = param;
        vm.model.searchPanelToggle = false;

        var rptDesign = "leave_Details_report.rptdesign";


        var url = CommonLogicService.getReportUrl(rptDesign, getSearchParamMap(param));
        vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
      }
    }

    vm.loadCrewID = function () {
      vm.model.searchCriteria.crewId = vm.model.searchCriteria.crew.crewId;
    };

    function getSearchParamMap(param) {
      var searchParamMap = {};
      searchParamMap["fromDate"] = param.fromDate;
      searchParamMap["toDate"] = param.toDate;
      searchParamMap["crewBase"] = (!!param.crewBase && !!param.crewBase.airPortCode) ? param.crewBase.airPortCode:'';

      if (!!param.crewType && !!param.crewType.crewTypeCode) {
        searchParamMap["crewType"] = param.crewType.crewTypeCode;
      }

      if (!!param.crewId) {
        searchParamMap["crewId"] = param.crewId;
      }
      searchParamMap["leaveTypes"] = getLeaveTypesParamValue(param);
      return searchParamMap;
    }

    function getLeaveTypesParamValue(param) {
      var leaveTypes = '';
      for (var j = 0; j < param.leaveTypes.length; j++) {
        if (j == 0) {
          leaveTypes = param.leaveTypes[j].eventCode;
        } else {
          leaveTypes += ',' + param.leaveTypes[j].eventCode;
        }
      }
      return leaveTypes;

    }

    function isValidSearchParams(params) {
      setDateValidationFlags();
      if ((!!vm.model.searchCriteria.fromDate && !vm.model.masterList.fromTimeInvalid) ||
        (!!vm.model.searchCriteria.toDate && !vm.model.masterList.toTimeInvalid)
      ) {
        return true;
      }
      return false;
    }

    function setDateValidationFlags() {
      //if from date invalid
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromTimeInvalid = true;
      } else {
        vm.model.masterList.fromTimeInvalid = false;
      }
      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toTimeInvalid = true;
      } else {
        vm.model.masterList.toTimeInvalid = false;
      }

    }

    function isDateFormatInvalid(date) {
      if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
        return true;
      }
      return false;
    }

    vm.loadCrewListByType = function (crewType) {
      loadCrewList(crewType);
    };

    (function() {
      // base list
      CommonMasterData.getCrewBaseList(function(crewBases) {
        vm.model.masterList.crewBaseList = crewBases;
      }, function() {
        console.log('Crew Base List retrieval error');
      });

    })();

  }
}());
